module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/006-tanzania-ae3ff040701871f9beaf88b2f3e0004a.svg";